import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { getCurrency } from 'core/utils/cultures/unit'
import { Row, Col, List, Checkbox } from 'core/components/ui'
import { font, greys } from 'assets/themes/theme-default'
import { FormattedMessage } from 'react-intl'
import { configuratorShape } from '../../shapes'

const ClickableRow = styled(Row)`
  cursor: pointer;
  font-size: ${font.size.base};
  line-height: ${isMobile && 'normal'};
`
const ColDataInput = styled(Col)`
  padding-top: 2px;
`

const ColDataLabel = styled(Col)`
  color: ${greys.dark1};
  font-weight: ${font.weight.base};
`

const ColDataValue = styled(Col)`
  text-align: right;
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.bold};
`
const RenderItem = props => {
  const { configurator, setConfigurator, item } = props
  const { serviceContracts } = configurator

  const handleOnChangeSelectionOptions = () => {
    const isSelected = !serviceContracts
      ? false
      : serviceContracts.filter(el => el.label === item.label).length > 0

    let extendedOptions = serviceContracts ? [...serviceContracts] : []

    if (!isSelected) {
      extendedOptions.push(item)
    } else {
      extendedOptions = serviceContracts.filter(el => el.label !== item.label)
    }

    setConfigurator({
      ...configurator,
      serviceContracts: extendedOptions
    })
  }

  return (
    <List.Item data-test="component-configurator-contractsList-item">
      <ClickableRow
        type="flex"
        style={{ width: '100%' }}
        align="top"
        gutter={5}
        onClick={() => handleOnChangeSelectionOptions()}
        data-test="configurator-contractsList-item-ClickableRow"
      >
        <ColDataInput lg={2} xs={3}>
          <Checkbox
            checked={
              !serviceContracts
                ? serviceContracts
                : serviceContracts.filter(el => el.label === item.label).length > 0
            }
            data-test="configurator-contractsList-item-radio"
          />
        </ColDataInput>

        <ColDataLabel lg={18} xs={14} data-test="configurator-contractsList-item-label">
          {item.label}
        </ColDataLabel>
        <ColDataValue data-test="configurator-contractsList-item-price" lg={4} xs={5}>
          {item.price > 0 ? (
            <>
              <FormattedMessage
                id="configurator-options-optionsList-card-price"
                values={{ price: item.price }}
              />{' '}
              {getCurrency()}
            </>
          ) : (
            <span data-test="configurator-contractsList-list-included-price">
              <FormattedMessage id="configurator-options-optionsList-card-included" />
            </span>
          )}
        </ColDataValue>
      </ClickableRow>
    </List.Item>
  )
}

RenderItem.propTypes = {
  item: PropTypes.shape().isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default RenderItem
